import ArrowEnterIcon from '../../../../icons/arrow-enter.icon';
import LaptopCheckIcon from '../../../../icons/laptop-check.icon';
import CalendarIcon from '../../../../icons/calendar.icon';
import "./recommended-tool.styles.scss";
import integrationUtils from '../../../../../Utils/integration.utils';

const ToolLicenseRow = ({ license, onRowClick = () => { } }) => {
  return (
    <tr className="tool-license-row" onClick={onRowClick}>
      <td>
        <div className="flex flex-col">
          <div className="flex items-center gap-8">
            <ArrowEnterIcon />
            {license?.ProductName}
          </div>
          {license.IsMonitoredBySoc && (
            <div className="flex items-center gap-4 monitored-by-soc-wrapper">
              <LaptopCheckIcon />
              <span className="monitored-by-soc">Monitored by SOC</span>
            </div>
          )}
        </div>
      </td>
      <td>{license.Quantity}</td>
      <td>
        <div className="flex items-center gap-8">
          <CalendarIcon className="f-darkgrey" />
          {license.ContractEndDate}
        </div>
      </td>
      <td>{license.Cost}</td>
      <td>{license.TotalText}</td>
    </tr>
  );
};

const RecommendedToolRow = ({ tool, recommendedTools, onRowClick = () => {} }) => {
  if (tool.IsCovered) {
    return (
      <>
        <tr className="recommended-tool-row">
          <td>
            <div className="flex items-center gap-8">
              <img
                className="tool-icon"
                width="14"
                height="14"
                src={integrationUtils.getImagePath(tool?.ToolId, tool?.ToolIcon)}
                alt={tool?.ToolName}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "/images/attack-surface/generic2.svg";
                }}
              />
              <span>{tool.ToolName}</span>
            </div>
          </td>
          <td></td>
        </tr>
        <tr>
          <td colSpan={5}>
            <div className='d-flex justify-content-center'>
              <span className="already-covered-tool text-center">
                License cost already covered in another recommendation
              </span>
            </div>
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr className="recommended-tool-row">
        <td>
          <div className="flex items-center gap-8">
            <img
              className="tool-icon"
              width="14"
              height="14"
              src={integrationUtils.getImagePath(tool?.ToolId, tool?.ToolIcon)}
              alt={tool?.ToolName}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "/images/attack-surface/generic2.svg";
              }}
            />
            <span>{tool.ToolName}</span>
          </div>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      {/* {recommendedTools?.map((license, index) => ( */}
        <ToolLicenseRow
          key={`${tool.toolName}-license`}
          onRowClick={()=>{onRowClick(tool)}}
          license={tool}
        />
      {/* ))} */}

    </>
  );
};

export default RecommendedToolRow;